import { getWaitPayOrderList, confirmGetCash, goPayMoney, sendTechnicianH5Url } from "@/api/api"
import { debounce, getNewDay } from '@/utils/index.js'
export default {
  data() {
    return {
      serverType:[
        {label:'安装',value:1},
        {label:'维修',value:2},
        {label:'设计',value:3},
        {label:'调试',value:4},
        {label:'换门方向',value:5},
        {label:'预埋管线',value:6},
        {label:'拆机',value:8},
        {label:'二次安装',value:9},
        {label:'上门清洁',value:10},
        {label:'其它',value:11},
      ],
      orderMsg: {},
    }
  },
  created() {
    this.orderMsg = JSON.parse(localStorage.getItem("orderMsg")) || {}
    if(this.orderMsg.risCode) {
      this.getData()
    }
  },
  computed: {
    integer(){
      let tep = this.payMoney ? this.payMoney.toString().split(".") : ['0','00'];
      return tep[0];
    },
    decimals(){
      let tep = this.payMoney ? this.payMoney.toString().split(".") : ['0','00'];
      return  tep[1];
    },
  },
  methods: {
    getData() {
      let query = {
        risCode: this.orderMsg.risCode,
        type: this.orderMsg.type,
        technicianCode: this.orderMsg.technicianCode
      }
      let technicianCodeSession = localStorage.getItem("technicianCodeSession") || ''
      if(!technicianCodeSession) {
        query.code = localStorage.getItem("code") || ''
        // localStorage.removeItem("code")
      }else {
        query.technicianCodeSession = technicianCodeSession
      }
      getWaitPayOrderList(query).then( res => {
        console.log('待支付返参',res)
        if (res.status == 200 && res.data.data) {
          this.orderList = res.data.data || []
          this.payMoney = res.data.payMoney || 0 //付款金额
          this.payStatus = res.data.status || 0 //支订单状态 : 0. 待支付， 1.支付中 ，2.已支付 ，3.已取消
          this.discountMoney = res.data.discountMoney || 0 //优惠金额
          this.methodType = res.data.methodType || '0' //1为taro
          if (this.methodType == 1) {
            let createTime = res.data.data && res.data.data.length ? res.data.data[0].createTime : ''
            let arr = createTime.split(' ') //创单时间 年月日 时分秒
            this.showDate = getNewDay(arr[0], 3) + ' ' + arr[1] //取72小时后的日期
            console.log(this.showDate)
          }
          console.log('待支付返参methodType',this.methodType)
          if (res.data.technicianCodeSession) {
            localStorage.setItem("technicianCodeSession",res.data.technicianCodeSession)
          }
          this.orderList = this.orderList.map(item => {
            let orderSubInfo = item.orderSubInfo.map(ele => {
              return {
                ...ele,
                isOpen: false
              }
            })
            item.orderSubInfo = JSON.parse(JSON.stringify(orderSubInfo))
            return {
              ...item,
              isOpen: false
            }
          })
          this.dataList = JSON.parse(JSON.stringify(this.orderList))
        }else if (res.data.status === 0 && res.data.isAuthorize === 0) {//参数错误 重新授权一次
          this.reAuthorize()
        }
      })
    },
    showOrderList() {
      this.allOpen = !this.allOpen
      let arr = []
      if (this.allOpen) {
        this.orderList.length ? arr.push(this.orderList[0]) : []
      }else {
        arr = JSON.parse(JSON.stringify(this.orderList))
      }
      this.dataList = JSON.parse(JSON.stringify(arr))
    },
    /* 确认收到现金 */
    confirmCash: debounce(function () {
      let query = {
        type: 2,
        payUser: this.orderMsg.technicianCode,//工程师工号
        payStatus: 2,
        paySource: 2
      }
      if(this.methodType == 1){//taro
        query.d2c = 1
        query.listRis = this.dataList.length ? this.dataList[0].id : '' //订单纬度 链接上的riscode
      } else {//tss
        query.listRis = this.orderList.length ? this.orderList[0].risCode : '' //riscode
      }
      confirmGetCash(query).then( res => {
        if (res.status == 200) {
          this.getData()
        }else if (res.status != 200 && res.isAuthorize === 0) {//参数错误 重新授权一次
          this.reAuthorize()
        }
      })
    },500),
    /* 去付款 获取短链 */
    goPay() {
      let params = {
        technicianCodeSession: localStorage.getItem("technicianCodeSession") || '',
        code: localStorage.getItem("code") || '',
        risNo: this.orderMsg.risCode,
        technicianCode: this.orderMsg.technicianCode
      }
      if (this.methodType == 1) {
        params.channel = 'taro'
      }
      sendTechnicianH5Url(params, this.$authHttp).then(result => {
        console.log(result,'=======')
        if(result.code == 200){
          window.location.href = result.h5Url
        }else if (result.code == 300 && result.isAuthorize === 0) {//参数错误 重新授权一次
          this.reAuthorize()
        }
      })
    },
    /* 匹配服务类型 */
    matchServerType(val) {
      let map = new Map()
      this.serverType.forEach( item => {
        map.set(item.value,item.label)
      })
      return map.get(val) ? map.get(val) : ''
    },
    // 重新授权
    reAuthorize() {
      localStorage.removeItem("technicianCodeSession")
      let str = this.$http + 'taro-pay/?risCode=' + this.orderMsg.risCode + 
       '&type=' + this.orderMsg.type + '&technicianCode=' + this.orderMsg.technicianCode + '&brand=' + this.orderMsg.brand
        console.log('参数错误重新授权,授权', str)
       window.location.replace(str)
    }
  }
}